"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkboxBoxedLabel = exports.checkboxLabel = exports.checkboxInput = void 0;

var _stylitas = require("@creditas/stylitas");

const checkboxLabel = ({
  theme
}) => (0, _stylitas.css)`
  position: relative;
  display: grid;
  color: ${theme.bLabelbuttonColor};
  grid-template-columns: 24px calc(100% - 30px) 0px;
  grid-column-gap: 6px;
  ${_stylitas.utilities.typography.h6(theme)};
  font-weight: 300;

  &::before {
    content: ' ';
    border-radius: 0px;
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: 1px solid ${_stylitas.utilities.palette.color(theme, 'secondary06')};
    margin-right: 0.25rem;
    cursor: pointer;
  }

  input[type='checkbox'][disabled] + &::before {
    border: 1px solid ${_stylitas.utilities.palette.color(theme, 'neutral04')};
  }

  &::after {
    content: 'L';
    font-size: 12px;
    font-weight: normal;
    text-align: center;
    color: ${_stylitas.utilities.palette.color(theme, 'secondary06')};
    top: -5px;
    left: 1px;
    position: absolute;
    width: 24px;
    height: 24px;
    transform: scaleX(-1) rotate(-40deg) translate3d(-2px, 2px, 0);
    display: none;
    z-index: 1;
  }
`;

exports.checkboxLabel = checkboxLabel;

const checkboxInput = ({
  theme,
  boxed
}) => (0, _stylitas.css)`
  position: absolute;
  opacity: 0;

  &:checked + label::before {
    content: ' ';
    background-color: ${_stylitas.utilities.palette.color(theme, 'secondary01')};
    border: 1px solid ${_stylitas.utilities.palette.color(theme, 'secondary05')};
  }

  &:checked + label::after {
    display: inline-block;
    color: ${_stylitas.utilities.palette.color(theme, 'secondary05')};
  }

  &[checked][disabled] + label::before {
    content: ' ';
    background-color: ${_stylitas.utilities.palette.color(theme, 'neutral02')};
    border: 1px solid ${_stylitas.utilities.palette.color(theme, 'neutral04')};
  }

  &[checked][disabled] + label::after {
    color: ${_stylitas.utilities.palette.color(theme, 'neutral06')};
  }

  ${boxed && `
    &:checked + label {
      background-color: ${_stylitas.utilities.palette.color(theme, 'secondary01')};
      border: 1px solid ${_stylitas.utilities.palette.color(theme, 'secondary05')};
    }

    &:disabled + label {
      background-color: ${_stylitas.utilities.palette.color(theme, 'neutral02')};
      border: 1px solid ${_stylitas.utilities.palette.color(theme, 'neutral04')};
    }
  `}
`;

exports.checkboxInput = checkboxInput;

const checkboxBoxedLabel = ({
  theme,
  fullWidth
}) => (0, _stylitas.css)`
  position: relative;
  display: ${fullWidth ? `block` : `inline-block`};
  border-radius: 3px;
  background-color: ${_stylitas.utilities.palette.color(theme, 'neutral01')};
  border: 1px solid ${_stylitas.utilities.palette.color(theme, 'neutral03')};
  color: ${_stylitas.utilities.palette.color(theme, 'neutral07')};
  font-size: 16px;
  font-weight: 300;
  cursor: pointer;
  padding: 1rem 1rem 1rem 3rem;

  &:hover {
    border-color: ${_stylitas.utilities.palette.color(theme, 'secondary05')};
    background-color: ${_stylitas.utilities.palette.color(theme, 'neutral01')};
    box-shadow: 0 10px 25px 0 ${_stylitas.utilities.palette.color(theme, 'neutral03')};
  }

  &::before {
    content: '';
    border-radius: 0px;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 0.2rem;
    border: 1px solid ${_stylitas.utilities.palette.color(theme, 'neutral03')};
    position: absolute;
    top: 0.75rem;
    left: 0.75rem;
  }

  input[type='checkbox'][disabled] + &::before {
    border: 1px solid ${_stylitas.utilities.palette.color(theme, 'neutral04')};
  }

  input[type='checkbox'][disabled] + &::after {
    color: ${_stylitas.utilities.palette.color(theme, 'neutral06')};
  }

  input[type='checkbox'][disabled] + & {
    cursor: default;
  }

  input[type='checkbox'][disabled] + &:hover {
    box-shadow: none;
  }

  &::after {
    content: 'L';
    font-weight: normal;
    text-align: center;
    color: ${theme.secondary06};
    font-size: 0.75rem;
    position: absolute;
    top: 0.75rem;
    left: 0.5rem;
    width: 1.5rem;
    height: 1.5rem;
    transform: scaleX(-1) rotate(-40deg) translate3d(-2px, 2px, 0);
    display: none;
    z-index: 1;
  }
`;

exports.checkboxBoxedLabel = checkboxBoxedLabel;